import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { MonthlySalesTarget } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 0230. チーム月間売上目標一覧
 * [GET] /workspaces/:identifier/teams/:team_id/monthly_sales_targets
 */
type Props = {
  identifier: string;
  team_id: number;
};

type MonthlySalesTargetsResponse = {
  previous_sales_targets: MonthlySalesTarget[];
  current_sales_targets: MonthlySalesTarget[];
  next_sales_targets: MonthlySalesTarget[];
};

const monthlySalesTargets = (props: Props): Promise<MonthlySalesTargetsResponse> => {
  return axios.get(`/api/workspaces/${props.identifier}/teams/${props.team_id}/monthly_sales_targets`, {
    params: props,
  });
};

export const useMonthlySalesTargets = (props: Props) => {
  return useQuery({
    queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'monthly_sales_targets'],
    queryFn: () => monthlySalesTargets(props),
  });
};

export const useInvalidateMonthlySalesTargets = (props: Props) => {
  const invalidate = async () => {
    await queryClient.invalidateQueries({
      queryKey: ['workspaces', props.identifier, 'teams', props.team_id, 'monthly_sales_targets'],
    });
  };

  return { invalidate };
};
